import AppConstants from "../appConstants";

class FormatFieldHelper {

  formatAmount(amount) {

    // posição do "."
    let i = amount.length;

    while (i > 3) {
      if (amount.includes('.')) {
        if (amount.substring(0, amount.indexOf('.') - 3).length >= 1) {
          amount = amount.substring(0, amount.indexOf('.') - 3) + '.' + amount.substring(amount.indexOf('.') - 3);
          i = amount.indexOf('.');
        }
      } else {
        amount = amount.substring(0, amount.length - 3) + '.' + amount.substring(amount.length - 3);
        i = amount.indexOf('.');
      }
    }

    return amount;
  }

  formatPrice(price) {

    if (price.includes('.')) {
      price = price.replace('.', ',');

      if (price.substring(price.indexOf(',') + 1).length === 1) {
        price = `${price}0`;
      }
    } else {
      price = `${price},00`;
    }
    price = `${this.formatAmount(price.substring(0, price.indexOf(',')))}${price.substring(price.indexOf(','))}`;

    return price;
  }

  formatFieldLenght(field, fieldLength) {
    if (!field) {
      return '';
    }

    if (field.length > fieldLength) {
      field = field.substring(0, fieldLength) + '...';
    }

    return field;
  }

  formatDocument(field) {
    if (field.length === 11) {
      return this.formatFieldCPF(field);
    }
    if (field.length === 14) {
      return this.formatFieldCNPJ(field);
    }
    return field;
  }
  formatFieldCPF(field) {
    if (field.length === 11) {
      return `${this.formatAmount(field.substring(0, 9))}-${field.substring(9, 11)}`;
    }
    return field;
  }

  formatFieldCNPJ(field) {
    if (field.length === 14) {
      return `${this.formatAmount(field.substring(0, 8))}/${field.substring(8, 12)}-${field.substring(12)}`;
    }
    return field;
  }

  formatFieldPhone(field) {
    // phone field -> DDD + phone
    if (field.length === 11) {
      return `(${field.substring(0, 3)}) ${field.substring(3, 7)}-${field.substring(7)}`;
    }
    return '';
  }

  formatFieldCellPhone(field) {
    // phone field -> DDD + phone
    if (field.length === 11) {
      return this.formatFieldPhone(field);
    }

    if (field.length === 12) {
      return `(${field.substring(0, 3).trim()}) ${field.substring(3, 8)}-${field.substring(8)}`;
    }
    return '';
  }

  removeAccents(originalString) {
    return originalString
      .replace(/[áàãâä]/gi, 'a')
      .replace(/[éè¨ê]/gi, 'e')
      .replace(/[íìïî]/gi, 'i')
      .replace(/[óòöôõ]/gi, 'o')
      .replace(/[úùüû]/gi, 'u')
      .replace(/[ç]/gi, 'c')
      .replace(/[ñ]/gi, 'n')
      .replace(/[^a-zA-Z0-9]/g, ' ');
  }

  unmaskField(field) {
    return field.replace(/\D+/g, '');
  }

  normalizeDuration(duration) {
    return duration.replace(/_/g, '0');
  }

  formatEmpty(value) {
    if (value) {
      return value;
    }
    return '';
  }

  getMasks() {
    return {
      cpf: [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
      phone: ['(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      cellphone: ['(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    };
  }

  convertModelToFormData(model, form = null, namespace = '') {
    let formData = form || new FormData();
    // let formKey;

    for (let propertyName in model) {
      if (!model.hasOwnProperty(propertyName) || !model[propertyName]) continue;
      let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
      if (model[propertyName] instanceof Date)
        formData.append(formKey, model[propertyName].toISOString());
      else if (model[propertyName] instanceof Array) {
        model[propertyName].forEach((element, index) => {
          const tempFormKey = `${formKey}[${index}]`;
          this.convertModelToFormData(element, formData, tempFormKey);
        });
      }
      else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
        this.convertModelToFormData(model[propertyName], formData, formKey);
      else
        formData.append(formKey, model[propertyName].toString());
    }
    return formData;
  }

  getOriginCode(appActiveUser) {
    if (appActiveUser && appActiveUser.code) {
      return appActiveUser.code;
    }
    return AppConstants.PLATFORM_ORIGIN_CODE;
  }

  limitFieldLength(text, limit) {
    if (text.length > limit) {
      return text.substring(0, limit).concat('...');
    }
    return text;
  }

  replaceAll(value, searchValue, replaceValue) {
    return value.replace(new RegExp(searchValue, 'g'), replaceValue);
  }

  replaceAnchorTagToText(text) {
    const reg = new RegExp(/<a(\s[^>]*)?>(.*?)<\/a>/ig);
    if (reg.test(text)) {
      return text.replace(reg, "$2");
    }
    return text;
  }

  linkify(text) {
    const urlRegex = /(\b(http?|https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(urlRegex, function (url) {
      return `<a href="${url}" target="_blank">${url}</a>`
    });
  }
  linkifyMobile(text) {
    // TODO - CHANGE TO REACT APP
    const urlRegex = /(\b(http?|https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(urlRegex, function (url) {
      return `<a href="#" onclick="if(window.cordova && window.cordova.InAppBrowser) {window.cordova.InAppBrowser.open('${url}', '_system');} else { window.open('${url}', '_blank');}">${url}</a>`;
      // return `<a href="${url}" target="_blank">${url}</a>`
    });
  }

  validateCPF(strCPF) {
    var sum = 0;
    var resto = 0;
    if (strCPF.length < 11 || strCPF.length > 11) return false;
    if (strCPF == "00000000000") return false;

    for (let i = 1; i <= 9; i++) sum = sum + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    // for (i = 1; i <= 9; i++) sum = sum + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    resto = (sum * 10) % 11;

    if ((resto == 10) || (resto == 11)) resto = 0;
    if (resto != parseInt(strCPF.substring(9, 10))) return false;

    sum = 0;
    // for (i = 1; i <= 10; i++) sum = sum + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    for (let i = 1; i <= 10; i++) sum = sum + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    resto = (sum * 10) % 11;

    if ((resto == 10) || (resto == 11)) resto = 0;
    if (resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }

  validateCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    var a = new Array();
    var b = new Number;
    var c = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    var x = new Number;
    for (let i = 0; i < 12; i++) {
      a[i] = cnpj.charAt(i);
      b += a[i] * c[i + 1];
    }
    if ((x = b % 11) < 2) { a[12] = 0 } else { a[12] = 11 - x }
    b = 0;
    for (let y = 0; y < 13; y++) {
      b += (a[y] * c[y]);

    }
    if ((x = b % 11) < 2) { a[13] = 0; } else { a[13] = 11 - x; }
    if ((cnpj.charAt(12) != a[12]) || (cnpj.charAt(13) != a[13])) {
      return false;
    }
    return true;
  }

  removeDuplicateItem(arr) {
    return [...new Set(arr)].join(".");
  }

  obfuscateText(text) {
    const visibleLength = 10;
    if (text.length <= visibleLength) {
      return text; 
    }

    const hiddenPart = '*'.repeat(text.length - visibleLength);
    const visiblePart = text.slice(-visibleLength);
    return hiddenPart + visiblePart;
  }
}

export default new FormatFieldHelper();
